import React from "react";
import ModalWrapper from './ModalWrapper';

const TransformacaoSocial = props => {
  return(
    <ModalWrapper
      {...props}
    >
      <div>
        <h4>Transformacao Social</h4>
        <p>Buscamos transformar a sociedade fortalecendo a cadeia produtiva da alimentação saudável e sustentável e realizando ações de mobilização, em conjunto com nossos públicos de relacionamento. Conheça alguns dos programas e projetos apoiados pelo Instituto GPA:</p>
        <ul className="list-unstyled">
          <li>
            <a target="_blank" href="http://www.arredondar.org.br?utm_source=SiteSustentabilidade&utm_medium=Hub&utm_term=ConceitoSust">
              Movimento Arredondar
            </a>
          </li>
          <li>
            Agenda Solidária
          </li>
          <li>
            <a target="_blank" href="https://content.paodeacucar.com/especiais/amigos-do-bem-pao-de-acucar?utm_source=SiteSustentabilidade&utm_medium=Hub&utm_term=ConceitoSust">
              Doação Online
            </a>
          </li>
          <li>
            Desafio Conexsus
          </li>
          <li>
            Horta Social
          </li>
        </ul>
      </div>
    </ModalWrapper>
  );
};

export default TransformacaoSocial;



// WEBPACK FOOTER //
// ./src/components/TransformacaoSocial.js